import { useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Form from "rc-field-form";
import { CardBody } from "reactstrap";
import Header from "../Layout/Header";
import FormContent from "../../General/Jobs/Form/Content";
import { useSettingsOnboarding } from "../context";
import useApi from "../../../../utils/api";
import { generateErrorsConfigForForm } from "../../../../utils/helpers/errors";
import { useCompany } from "../../../../utils/hooks/company";

function Job() {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const company = useCompany();
	const { authPost } = useApi();
	const { submit, error } = useSettingsOnboarding();

	const call = useCallback(
		(values) => {
			if (!company?.id) {
				return;
			}
			return authPost("/jobs", {
				data: { company: company.id, ...values },
			});
		},
		[company?.id, authPost],
	);

	const onFinish = useCallback(
		(values) => {
			submit(true, call(values));
		},
		[submit, call],
	);

	const saveAndRepeat = useCallback(() => {
		const values = form.getFieldsValue();
		submit(false, call(values), () =>
			toast.success(t("job-created")),
		);
		form.resetFields();
		form.setFieldsValue({
			status: "active",
			salary: 0,
		});
	}, [form, submit, call, t]);

	useEffect(() => {
		form.setFieldsValue({
			status: "active",
			salary: 0,
		});
	}, [form]);

	useEffect(() => {
		const fieldErrors = generateErrorsConfigForForm(
			[
				"code",
				"description",
				"status",
				"group",
				"family",
				"skills",
				"license",
			],
			error,
		);
		form.setFields(fieldErrors);
	}, [error, form]);

	return (
		<Form form={form} onFinish={onFinish}>
			<Header saveAndRepeat={saveAndRepeat} />

			<CardBody>
				<FormContent form={form} />
			</CardBody>
		</Form>
	);
}

export default Job;
